import { _ as _define_property } from "@swc/helpers/_/_define_property";
import Decimal from 'decimal.js';
import { InvoiceDisplayStatus } from 'anchor-scout-common/types';
import { routes } from '~/constants';
import { utils } from '~/utils';
import { MoneyModel } from './MoneyModel';
import { fromDateStampObject } from './time';
import { timeModel } from '.';
export var PayoutSummaryStatus = /*#__PURE__*/ function(PayoutSummaryStatus) {
    PayoutSummaryStatus["Paid"] = "Paid";
    PayoutSummaryStatus["Scheduled"] = "Scheduled";
    return PayoutSummaryStatus;
}({});
export class PayoutsSummaryPayoutModel {
    static fromDTO(dto) {
        return new PayoutsSummaryPayoutModel({
            id: dto.id,
            date: fromDateStampObject(dto.date),
            amount: MoneyModel.fromDTO(dto.amount),
            status: dto.status
        });
    }
    formattedDate() {
        return timeModel.formatDateLong(this.data.date) + (this.isFuture() ? '*' : '');
    }
    isFuture() {
        return this.data.status === "Scheduled";
    }
    isPaid() {
        return this.data.status !== "Scheduled";
    }
    statusText() {
        switch(this.data.status){
            case "Paid":
                return 'Paid';
            case "Scheduled":
                return 'Scheduled';
        }
    }
    redirectURL() {
        if (this.data.id != null) {
            const payoutsParam = {
                selected: this.data.id
            };
            return this.generateURL(routes.payoutsDashboard, payoutsParam);
        } else {
            const invoicesParam = {
                status: [
                    InvoiceDisplayStatus.PaymentInitiated
                ]
            };
            return this.generateURL(routes.invoicesDashboard, invoicesParam);
        }
    }
    timestamp() {
        return this.data.date.getTime();
    }
    amount() {
        return this.data.amount.amount();
    }
    formattedAmount() {
        return this.data.amount.display();
    }
    uniqueKey() {
        return this.data.id || this.data.date.getTime().toString();
    }
    generateURL(pathname, params) {
        if (params) {
            const search = new URLSearchParams();
            Object.entries(params).forEach((param)=>{
                let [key, value] = param;
                search.set(key, Array.isArray(value) ? value.join(',') : value);
            });
            return "".concat(pathname, "?").concat(search);
        } else {
            return pathname;
        }
    }
    constructor(data){
        _define_property(this, "data", void 0);
        this.data = data;
    }
}
export class PayoutsSummaryModel {
    static fromDTO(dto) {
        return new PayoutsSummaryModel({
            paidThisMonth: MoneyModel.fromDTO(dto.paidThisMonth),
            processing: MoneyModel.fromDTO(dto.processing),
            payouts: (dto.payouts || []).map(PayoutsSummaryPayoutModel.fromDTO).slice(0, 5),
            hasEverHadPaidPayout: dto.hasEverHadPaidPayout
        });
    }
    static makeEmpty() {
        return new PayoutsSummaryModel({
            paidThisMonth: new MoneyModel(new Decimal(0)),
            processing: new MoneyModel(new Decimal(0)),
            payouts: [],
            hasEverHadPaidPayout: false
        });
    }
    formattedPaidThisMonth() {
        return utils.formatDollarAmount(this.model.paidThisMonth.amount());
    }
    formattedFuturePayouts() {
        return utils.formatDollarAmount(this.model.processing.amount());
    }
    isEmpty() {
        return this.model.payouts.length === 0;
    }
    hasEverHadPaidPayout() {
        return this.model.hasEverHadPaidPayout;
    }
    addPayouts(payouts) {
        return new PayoutsSummaryModel({
            paidThisMonth: payouts.filter((p)=>p.isFuture()).reduce((acc, curr)=>acc.add(curr.amount()), this.model.paidThisMonth),
            processing: payouts.filter((p)=>p.isPaid()).reduce((acc, curr)=>acc.add(curr.amount()), this.model.processing),
            payouts: [
                ...this.model.payouts,
                ...payouts
            ],
            hasEverHadPaidPayout: this.model.hasEverHadPaidPayout
        });
    }
    payouts() {
        return this.model.payouts;
    }
    mapPayouts(fn) {
        return this.model.payouts.map((payout, idx)=>{
            const isLast = idx === this.model.payouts.length - 1;
            return fn(payout, idx, isLast);
        });
    }
    constructor(model){
        _define_property(this, "model", void 0);
        this.model = model;
    }
}
